import { render, staticRenderFns } from "./CurrentRoutes.vue?vue&type=template&id=79dc1bed&scoped=true&"
import script from "./CurrentRoutes.vue?vue&type=script&lang=js&"
export * from "./CurrentRoutes.vue?vue&type=script&lang=js&"
import style0 from "./CurrentRoutes.vue?vue&type=style&index=0&id=79dc1bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc1bed",
  null
  
)

export default component.exports